import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const researchApi = {
  meta: () => axios.get(`${API}/research/meta`).then((r) => r.data),
  authorities: (params) => axios.get(`${API}/research/authorities`, { params }).then((r) => r.data),
  createAuthority: (body) => axios.post(`${API}/research/authorities`, body).then((r) => r.data),
  fromDocument: (docId) => axios.post(`${API}/research/authorities/from-document/${docId}`).then((r) => r.data),
  patchAuthority: (id, body) => axios.patch(`${API}/research/authorities/${id}`, body).then((r) => r.data),
  deleteAuthority: (id) => axios.delete(`${API}/research/authorities/${id}`).then((r) => r.data),
  propositions: (params) => axios.get(`${API}/research/propositions`, { params }).then((r) => r.data),
  propositionDetail: (id) => axios.get(`${API}/research/propositions/${id}`).then((r) => r.data),
  patchProposition: (id, body) => axios.patch(`${API}/research/propositions/${id}`, body).then((r) => r.data),
  createProposition: (body) => axios.post(`${API}/research/propositions`, body).then((r) => r.data),
  deleteProposition: (id) => axios.delete(`${API}/research/propositions/${id}`).then((r) => r.data),
  search: (body) => axios.post(`${API}/research/search`, body).then((r) => r.data),
  verifyCitation: (body) => axios.post(`${API}/research/verify-citation`, body).then((r) => r.data),
  facts: (matterId) => axios.get(`${API}/research/facts`, { params: { matterId } }).then((r) => r.data),
  citationCheck: (draftId, text) => axios.post(`${API}/drafts/${draftId}/citation-check`, { text }).then((r) => r.data),
};

export const VERIFICATION_LABEL = {
  VERIFIED_FROM_SOURCE: { label: "Verified from source", cls: "bg-success-bg text-success" },
  NEEDS_ADVOCATE_CONFIRMATION: { label: "Extracted — confirm", cls: "bg-warning-bg text-warning" },
  NEEDS_VERIFICATION: { label: "Needs verification", cls: "bg-warning-bg text-warning" },
  INTERNAL_ANALYSIS: { label: "Internal analysis", cls: "bg-muted text-ink-2" },
  VERIFIED_INTERNAL: { label: "Verified in library", cls: "bg-success-bg text-success" },
  FOUND_INTERNAL_UNCONFIRMED: { label: "In library — unconfirmed", cls: "bg-warning-bg text-warning" },
  FOUND_IN_UPLOADED_DOCUMENT: { label: "Found in uploaded document", cls: "bg-warning-bg text-warning" },
  NOT_FOUND_INTERNAL: { label: "Not in library", cls: "bg-danger/10 text-danger" },
};

export const STANCE_LABEL = { SUPPORTS: "Supports", CONTRARY: "Contrary", NEUTRAL: "Neutral" };

export function formatCitation(a, para) {
  const base = `${a.title}${a.citation ? `, ${a.citation}` : ""}${a.court && !a.citation ? ` (${a.court}${a.year ? `, ${a.year}` : ""})` : ""}`;
  return para ? `${base}, para ${para}` : base;
}

export function errMsg(e, fallback = "Request failed") {
  const d = e?.response?.data?.detail;
  return typeof d === "string" ? d : fallback;
}
